import { useState } from 'react';
import { useDeleteVisita } from '@offertify/query';
import type { Visita } from '@offertify/core';
import toast from 'react-hot-toast';
import { usePermissions } from '../../hooks/usePermissions';

export default function RecurrenceDelete({ visita, onSuccess }: { visita: Visita; onSuccess: () => void }) {
  const { hasPermission } = usePermissions();
  const mutation = useDeleteVisita();
  const [scope, setScope] = useState<'singola' | 'serie'>('singola');
  if (!hasPermission('visite:delete')) return null;
  return <div className="flex flex-wrap items-center gap-2">
    {visita.serie_id && <select aria-label="Ambito eliminazione" value={scope} onChange={event => setScope(event.target.value as typeof scope)} className="rounded border border-gray-300 p-2 text-sm"><option value="singola">Solo questa occorrenza</option><option value="serie">Intera serie, incluse eccezioni</option></select>}
    <button type="button" disabled={mutation.isPending} className="rounded border border-red-200 px-3 py-2 text-sm text-red-700" onClick={async () => {
      if (!window.confirm(scope === 'serie' ? 'Eliminare tutte le attività della serie, incluse quelle concluse e le eccezioni?' : 'Eliminare questa attività?')) return;
      try { await mutation.mutateAsync({ id: visita.id, scope }); toast.success('Attività eliminate'); onSuccess(); }
      catch (error: any) { toast.error(error.response?.data?.detail || 'Impossibile eliminare le attività'); }
    }}>Elimina</button>
  </div>;
}
